// src/app/ui/client/bg/star-shoot/social/index.tsx
'use client';
import React, { useState } from 'react';

import { APP_SOCIAL_LINKEDIN, APP_SOCIAL_LINE, APP_SOCIAL_WHATSAPP } from '@/consts/contact/social';
import LineColor from '@/ui/assets/svg/social/line/LineColor';
import LinkedInColor from '@/ui/assets/svg/social/linkedin/LinkedInColor';
import WhatsappColor from '@/ui/assets/svg/social/whatsapp/WhatsappColor';
import ExtLink from '@/ui/server/link/ExtLink';

import styles from './styles.module.css';

const SocialIconsList = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const handleMouseEnter = (index: number) => setActiveIndex(index);
  const handleMouseLeave = () => setActiveIndex(null);

  const socialLinks = [
    { href: APP_SOCIAL_LINKEDIN, label: 'LinkedIn', icon: <LinkedInColor /> },
    { href: APP_SOCIAL_LINE, label: 'Line', icon: <LineColor /> },
    { href: APP_SOCIAL_WHATSAPP, label: 'WhatsApp', icon: <WhatsappColor /> },
  ];

  return (
    <nav className={styles.socialIconsList}>
      <ul>
        {socialLinks.map((item) => (
          <li key={`social-${item.label.toLowerCase()}`} className={activeIndex === socialLinks.indexOf(item) ? styles.activeIcon : ''} onMouseEnter={() => handleMouseEnter(socialLinks.indexOf(item))} onMouseLeave={handleMouseLeave}>
            <ExtLink href={item.href} newTab ariaLabel={item.label} title={`Go to ${item.label}`} className={styles.link}>
              {item.icon}
            </ExtLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SocialIconsList;
